module.exports = __webpack_public_path__ + "static/media/激光切割双足机器人.2fd7ed8f.png";